<template>
  <v-app>
    <v-snackbar v-model="show" :color="color">
      {{ message }}
    </v-snackbar>

    <GlobalLoading />
    <router-view />

    <!-- Banner de Cookies -->
    <div
      v-if="!cookiesAccepted"
      class="fixed bottom-0 left-0 w-full bg-gray-900 text-white px-6 py-4 shadow-lg z-[9999] flex flex-col md:flex-row items-center justify-between gap-4"
    >
      <p class="text-sm md:text-base">
        Utilizamos cookies para melhorar sua experiência. Você pode aceitar ou recusar o uso de cookies.
      </p>

      <div class="flex gap-3">
        <button
          @click="acceptCookies"
          class="bg-blue-600 hover:bg-blue-700 transition px-4 py-2 rounded text-sm"
        >
          Aceitar
        </button>

        <button
          @click="declineCookies"
          class="bg-gray-700 hover:bg-gray-800 transition px-4 py-2 rounded text-sm"
        >
          Recusar
        </button>
      </div>
    </div>
  </v-app>
</template>

<script setup>
import { ref, onMounted, toRefs } from 'vue';
import GlobalLoading from '@/components/GlobalLoading.vue';
import { useToastStore } from '@/store/toast';

// TOAST
const toastStore = useToastStore();
const { show, color, message } = toRefs(toastStore);

// COOKIES
const cookiesAccepted = ref(false);

onMounted(() => {
  const saved = localStorage.getItem("cookies-accepted");
  if (saved === "yes" || saved === "no") {
    cookiesAccepted.value = true;
  }
});

function acceptCookies() {
  cookiesAccepted.value = true;
  localStorage.setItem("cookies-accepted", "yes");
}

function declineCookies() {
  cookiesAccepted.value = true;
  localStorage.setItem("cookies-accepted", "no");
}
</script>

<style scoped></style>
